/* eslint-disable */
import { faUser } from '@fortawesome/pro-light-svg-icons';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import {
  faPlusCircle as faPlusCircleSolid,
  faThumbsDown as faThumbsDownSolid,
  faThumbsUp as faThumbsUpSolid,
} from '@fortawesome/pro-solid-svg-icons';
import { faCircleXmark, faThumbsDown, faThumbsUp } from '@fortawesome/pro-thin-svg-icons';

import '../styles/CoverPageStyles.css';

import {
  faArrowUpFromSquare,
  faClosedCaptioning,
  faPlusCircle,
  faVolume,
  faHighDefinition,
  faAudioDescription,
} from '@fortawesome/pro-thin-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldHalved } from '@fortawesome/sharp-solid-svg-icons';
import { useEffect, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

import {
  useUpdateFavouritesMutation,
  useUpdateLikesMutation,
} from '../../forYou/mediaSlidersApiSlice';
import { Slider } from '../../shared/components/slider/Slider';
import { AuthContext } from '../../shared/context/auth-context';
import { convertTime } from '../../shared/util/helperfunctions';
import TakeAction from '../images/take-action.jpg';
import { AuthorContainer } from './AuthorContainer';
import { CoverDescription } from './CoverDescription';
import { CTA } from './CTA';
import { ProgrammeBlock } from './ProgrammeBlock';
import { RateBlock } from './RateBlock';
import { Recipe } from './Recipe';
import ReminderPopUp from './ReminderPopUp';
import { SharePopUp } from './SharePopUp';
import Workout from './Workout';
import { Button } from '../../shared/components/button/Button';
import { Tooltip } from '../../shared/components/tooltip/Tooltip';
import { HeaderNavigation } from '../../shared/headerNavigation/HeaderNavigation';
import { initialLocationKey } from '../../shared/util/enum';

export function ContentCover({ mediaObject }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const auth = useContext(AuthContext);

  const [updateFavourites] = useUpdateFavouritesMutation();
  const [updateLikes] = useUpdateLikesMutation();

  const [favourite, setFavourite] = useState(false);
  const [like, setLike] = useState(false);
  const [dislike, setDislike] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);
  const [remindOpen, setRemindOpen] = useState(false);
  const [isService, setIsService] = useState(false);
  const [activeDay, setActiveDay] = useState(false);
  const [likeDislikeOpen, setLikeDislikeOpen] = useState(false);

  const mediaType = pathname.split('/')[1];

  useEffect(() => {
    const previousPages = JSON.parse(sessionStorage.getItem('contentTypePreviousLocations')) || [];
    if (!previousPages[0] || previousPages[0] !== pathname) {
      previousPages.unshift(pathname);
      sessionStorage.setItem('contentTypePreviousLocations', JSON.stringify(previousPages));
    }
  }, [pathname]);

  useEffect(() => {
    if (mediaObject?._id) {
      setFavourite(mediaObject.favourite);
      setLike(mediaObject.like);
      setDislike(mediaObject.dislike);
    }
  }, [mediaObject]);

  useEffect(() => {
    setIsService(
      mediaObject?.category === 'service' || mediaObject?.chid?.startsWith('TA') || false
    );
  }, [mediaObject?.category, mediaObject?.chid]);

  useEffect(() => {
    document.getElementById('cover-page')?.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.setItem('pageReload', true);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);

  const getMediaUrl = () => {
    switch (mediaType) {
      case 'programme':
      case 'masterclass':
      case 'take-actions':
        return `/${mediaType}`;
      default:
        return '/media';
    }
  };

  const handleFavourite = () => {
    setFavourite((prev) => !prev);
    updateFavourites({
      token: auth.token,
      url: `${getMediaUrl()}/favourites`,
      mediaId: mediaObject._id,
    }).catch(console.error);
  };

  const handleLikeDislike = (target) => {
    const updateState = {
      like: () => {
        setLike(!like);
        setDislike(false);
      },
      dislike: () => {
        setDislike(!dislike);
        setLike(false);
      },
    };

    updateState[target]();

    updateLikes({
      token: auth.token,
      url: `${getMediaUrl()}/preference`,
      action: target,
      mediaId: mediaObject._id,
    }).catch(console.error);
  };

  const handleNavigation = () => {
    navigate(-1);
  };

  const getMainIcon = () => {
    if (likeDislikeOpen) return faCircleXmark;
    if (like) return faThumbsUpSolid;
    if (dislike) return faThumbsDownSolid;
    return faThumbsUp;
  };
  const getAriaLabel = () => {
    if (like) return t('rate.voted.like');
    if (dislike) return t('rate.voted.dislike');
    return t('rate.voted.none');
  };
  const getBackgroundImage = () =>
    mediaObject.chid?.startsWith('TA')
      ? TakeAction
      : mediaObject.background_image ||
        mediaObject.video_cover_image ||
        mediaObject.thumbnail_image;

  if (!mediaObject?.chid) return null;
  return (
    <>
      {remindOpen && <ReminderPopUp setRemindOpen={setRemindOpen} />}
      {shareOpen && <SharePopUp setShareOpen={setShareOpen} />}
      {likeDislikeOpen && (
        <RateBlock
          like={like}
          dislike={dislike}
          setLike={setLike}
          setDislike={setDislike}
          handleLikeDislike={handleLikeDislike}
          setLikeDislikeOpen={setLikeDislikeOpen}
          likeDislikeOpen={likeDislikeOpen}
        />
      )}

      <div className="page-container">
        <HeaderNavigation
          bottomBarActionButton={
            location.key !== initialLocationKey && {
              ariaLabel: t('nav.button.back'),
              onClick: handleNavigation,
              icon: {
                faIconDefinition: faChevronLeft,
                size: 'lg',
              },
              variant: 'icon-only',
              className: 'back-button',
            }
          }
        />
        <div className="hero" style={{ backgroundImage: `url(${getBackgroundImage()})` }}>
          <div className="hero-contents cover">
            <div className="splash-contents">
              <div
                className="title-cont fs-mask"
                style={{ paddingBottom: isService ? '30px' : '' }}
              >
                <h1>{mediaObject.title}</h1>
              </div>

              <div className="tag-line">
                <p className="type">
                  {mediaObject.chid.startsWith('TA')
                    ? t('FY005')?.toUpperCase()
                    : mediaObject.label}
                </p>
                {mediaObject.chid.startsWith('TA') && (
                  <FontAwesomeIcon icon={faShieldHalved} className="icon shield" />
                )}
                {mediaObject.category === 'service' && (
                  <FontAwesomeIcon icon={faUser} className="icon shield" />
                )}
                {!isService && mediaObject.length && (
                  <p className="fs-mask">{convertTime(mediaObject.length)}</p>
                )}
                {mediaType === 'programme' && (
                  <p className="fs-mask">{mediaObject.days.length} days</p>
                )}
                {mediaObject.type && !isService && (
                  <FontAwesomeIcon
                    icon={mediaObject.type === 'audio' ? faVolume : faHighDefinition}
                    className="icon"
                    title={mediaObject.type === 'audio' ? t('icon.audio') : t('icon.video')}
                  />
                )}
                {mediaObject.transcript && !isService && (
                  <FontAwesomeIcon
                    icon={faClosedCaptioning}
                    className="icon"
                    title={t('icon.captions')}
                  />
                )}
                {mediaObject.url_ad && (
                  <FontAwesomeIcon
                    icon={faAudioDescription}
                    className="icon"
                    title={t('icon.captions')}
                  />
                )}
              </div>

              <CoverDescription description={mediaObject.description} />

              {!mediaObject.chid.startsWith('TA') && (
                <div className="action-line">
                  <Tooltip content={favourite ? t('M004') : t('M005W')}>
                    <Button
                      ariaLabel={favourite ? t('M004') : t('M005W')}
                      variant="icon-only"
                      color="white"
                      onClick={handleFavourite}
                      icon={{
                        faIconDefinition: favourite ? faPlusCircleSolid : faPlusCircle,
                        size: '3x',
                        color: 'white',
                      }}
                    >
                      <span className="visuallyHidden">{favourite ? t('M004') : t('M005W')}</span>
                    </Button>
                  </Tooltip>

                  {!isService && (
                    <>
                      <Tooltip content={t('M022')}>
                        <Button
                          ariaLabel={getAriaLabel()}
                          color="white"
                          variant="icon-only"
                          onClick={() => setLikeDislikeOpen(!likeDislikeOpen)}
                          icon={{ faIconDefinition: getMainIcon(), size: '3x', color: 'white' }}
                        />
                      </Tooltip>
                      <Tooltip content={t('M006')}>
                        <Button
                          ariaLabel={t('M006')}
                          variant="icon-only"
                          color="white"
                          onClick={() => setShareOpen(true)}
                          icon={{
                            faIconDefinition: faArrowUpFromSquare,
                            size: '3x',
                            color: 'white',
                          }}
                        >
                          <span className="visuallyHidden">{t('M006')}</span>
                        </Button>
                      </Tooltip>
                    </>
                  )}
                </div>
              )}

              <CTA
                mediaType={mediaType}
                mediaObject={mediaObject}
                activeDay={activeDay}
                setActiveDay={setActiveDay}
              />
            </div>
          </div>
          <div className="fade" />
        </div>

        {mediaObject.category === 'recipe' && <Recipe recipe={mediaObject} />}
        {mediaObject.category === 'workout' && (
          <Workout exercises={mediaObject.exercises} equipment={mediaObject.equipment} />
        )}
        {mediaType === 'programme' && (
          <ProgrammeBlock programme={mediaObject} activeDay={activeDay} />
        )}
        {mediaObject.author?.author && mediaObject.author._id !== '645a407d2f5e5d00149daf9a' && (
          <AuthorContainer author={mediaObject.author} />
        )}
        {mediaObject.related_media?.length > 0 && (
          <div
            className={`${
              mediaObject.chid.startsWith('TA') ? 'negative-marg related' : 'related'
            } fs-exclude`}
          >
            <Slider
              title={mediaObject.chid.startsWith('TA') ? t('M074') : t('M072')}
              media={mediaObject.related_media}
            />
          </div>
        )}
      </div>
    </>
  );
}
